module.exports = __webpack_public_path__ + "static/3ds_benefits1-23fe663cf1b4c18f30398fdd5ed513fd.png";